import { useDispatch, useSelector } from "react-redux";
import useForm from "../../../hooks/useForm";
import * as AuthActions from "../../../store/auth/actions";
import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import "./style.scss";
import { textIdentifier } from "../../../textIdentifier";

export default function ChangePasswordModal({ handleClose = () => {} }) {
  const dispatch = useDispatch();
  const [apiError, setApiError] = useState("");
  const { changePasswordSuccess, changePasswordFailure, errorMessage } =
    useSelector((state) => state.auth);
 
  const handleSubmit = async (values) => {
    dispatch(AuthActions.changePasswordCta(values));
  };

  const {lang} = useSelector(state => state.main)

  const Form = useForm({
    initialValues: {
      password: "",
      new_password: "",
      confirm_password: "",
      apiError: "",
    },
    validate: ({ password, new_password, confirm_password }) => {
      const errors = {};
      if (!password) {
        errors.password = textIdentifier['please-enter-valid-password'][lang];
      }
      if (password.length < 6) {
        errors.password = textIdentifier['minimum-length-of-password-should-be-6'][lang];
      }
      if (new_password.length < 6) {
        errors.new_password = textIdentifier['minimum-length-of-password-should-be-6'][lang];
      }
      if (new_password !== confirm_password) {
        errors.confirm_password = textIdentifier["passwords-didn't-match"][lang];
      }
      return errors;
    },
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  useEffect(() => {
    if (changePasswordSuccess) {
      dispatch(AuthActions.changePasswordCtaInit());
      handleClose();
    }
    if (changePasswordFailure) {
      setApiError(errorMessage);
      dispatch(AuthActions.changePasswordCtaInit());
      Form.setSubmitting();
      Form.resetForm({
        password: "",
        new_password: "",
        confirm_password: "",
        apiError: "",
      });
    }
  }, [changePasswordSuccess, changePasswordFailure]);

  return (
    <Modal className="change-password-modal" show>
      <Modal.Body>
        <h3>{textIdentifier["change-password"][lang]}</h3>
        <form onSubmit={Form.handleSubmit}>
          <div className="form-group">
            <div id="helperText" className="form-text">
              {apiError}
            </div>
          </div>

          <div className="form-group">
            <label for="password" className="form-label">
              {textIdentifier["enter-old-password"][lang]}
            </label>
            <input
              type="password"
              placeholder={textIdentifier['min-6-characters'][lang]}
              className="form-control"
              id="password"
              value={Form.values.password}
              onChange={Form.handleChange}
              disabled={Form.isSubmitting}
            />
            <div id="helperText" className="form-text">
              {Form.errors.password}
            </div>
          </div>

          <div className="form-group">
            <label for="new_password" className="form-label">
              {textIdentifier["enter-new-password"][lang]}
            </label>
            <input
              type="password"
              placeholder={textIdentifier['min-6-characters'][lang]}
              className="form-control"
              id="new_password"
              value={Form.values.new_password}
              onChange={Form.handleChange}
              disabled={Form.isSubmitting}
            />
            <div id="helperText" className="form-text">
              {Form.errors.new_password}
            </div>
          </div>

          <div className="form-group">
            <label for="confirm_password" className="form-label">
              {textIdentifier["re-enter-new-password"][lang]}
            </label>
            <input
              type="password"
              placeholder={textIdentifier['min-6-characters'][lang]}
              className="form-control"
              id="confirm_password"
              value={Form.values.confirm_password}
              onChange={Form.handleChange}
              disabled={Form.isSubmitting}
            />
            <div id="helperText" className="form-text">
              {Form.errors.confirm_password}
            </div>
          </div>

          <div className="btn-container">
            <button
              type="button"
              onClick={handleClose}
              disabled={Form.isSubmitting}
              className="btn-outlined w-50"
            >
              {textIdentifier['cancel'][lang]}
            </button>
            <button
              disabled={Form.isSubmitting}
              type="submit"
              className="btn-contained w-50"
            >
              {textIdentifier['confirm'][lang]}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
